@if (displayPaymentTerm()) {
    <div class="px-3">
        <div class="row">
            <div class="col">
                @if (paymentTermRequired) {
                    <strong mark-required>{{ 'Zahlungsbedingung' | translate }}</strong>
                } @else {
                    <strong>{{ 'Zahlungsbedingung' | translate }}</strong>
                }
            </div>
        </div>
        @if (editable) {
            <div class="row align-items-center cursor-pointer mx-auto" (click)="openPaymentTermSelection()">
                @if (paymentTerm) {
                    <div class="col-auto ps-0" [title]="paymentTerm.valueDisplayLong">
                        {{ paymentTerm.valueDisplay }}
                    </div>
                }

                <div class="col-auto p-0">
                    <button class="text-primary" mat-icon-button>
                        <em class="fas fa-pen"></em>
                    </button>
                    @if (paymentTerm && !paymentTermRequired) {
                        <button
                            [matTooltip]="'Zahlungsbedingung entfernen' | translate"
                            mat-icon-button
                            color="warn"
                            (click)="deleteCurrent($event)"
                        >
                            <em class="fas fa-trash"></em>
                        </button>
                    }
                </div>
            </div>
        } @else {
            <div class="row align-items-center mx-auto">
                @if (paymentTerm) {
                    <div class="col-auto ps-0" [title]="paymentTerm.valueDisplayLong">
                        {{ paymentTerm.valueDisplay }}
                    </div>
                }
            </div>
        }
    </div>
}
